import { SelectOption } from 'dcloud-shared-ui';

export const getQuantityOptions = (max: number): SelectOption<string>[] =>
  Array(max)
    .fill(0)
    .map((_, i) => ({
      name: `${i + 1}`,
      value: String(i + 1),
    }));
